<template>
    <div class="topbar">
        <img id="logo" src="../assets/logo.png">
        <h1>{{$root.headline}}</h1>
        <h2>{{$root.subheadline}}</h2>
    </div>
</template>

<script>
export default {

}
</script>

<style>
    .topbar {
        height: 100px;
        display: flex;
        flex-direction: row;
        padding-left: 78px;
        padding-right: 64px;
        justify-content: space-between;
        align-items: center;
        box-shadow: 0px 14px 29px #00000029;
        margin-bottom: 37px;
        background-color: #fff;
        position: relative;
        z-index: 1000;
    }

    .topbar h1, .topbar h2 {
        color: #7F7F7F;
    }

    .topbar h1 {
        font-family: 'Demi';
        font-size: 34px; 
    }

    .topbar h2 {
        font-family: 'Regular';
        font-size: 26px; 
        font-weight: 200;
    }

    #logo {
        max-width: 260px;
        max-height: 37px;
    }

    @media only screen and (max-device-width: 1366px) {
        .topbar h1 {
            font-size: 28px; 
        }

        .topbar h2 {
            font-size: 20px; 
        }
    }
</style>